import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import {
  useSoFormStepsApi,
  useSoFormStepsState,
} from 'refactored/features/soForm/SoForm.context';
import FieldError from 'components/form/FieldError';
import { useTranslation } from 'react-i18next';

const RangeControls = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 4px;
  gap: 10px;
  height: 48px;
  width: 32px;
  height: 48px;
  background: var(--grey500);
  flex: none;
  flex-grow: 0;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 32px;
  &:disabled {
    background: var(--grey300);
    cursor: default;
  }
`;

const CustomInput = styled.input`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 12px 12px 16px;
  gap: 12px;
  width: 68px;
  height: 48px;
  background: var(--white);
  flex: none;
  flex-grow: 1;
  text-align: center;
  outline: none;
  border: none;
  border-left: 1px solid var(--grey300);
  border-right: 1px solid var(--grey300);
  box-shadow: inset 0px -4px 0px transparent;
  ${(props) =>
    !!props.isFocused &&
    css`
      box-shadow: inset 0px -4px 0px var(--primary500);
    `};
  ${(props) =>
    !!props.hasError &&
    css`
      box-shadow: inset 0px -4px 0px var(--error700);
    `};
`;

const SoFormLoadsAmountControl = ({ className, load }) => {
  // state
  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();

  //   value
  const field = 'number_of_items';
  const value = load.number_of_items;
  const displayValue = value >= 1 ? value : '';

  //   focus
  const [isFocused, setIsFocused] = useState(false);

  //   errors
  const errors = stepsState.configuration.errors;

  const hasEmptyError = !!errors.fieldsWithEmptyError.find(
    (e) => e.field === field && e.loadKey === load.loadKey
  );
  const showEmptyError =
    stepsState.configuration.showConfigurationErrors && hasEmptyError;

  const hasLogicError = !!errors.fieldsWithInvalidError.find(
    (e) => e.field === field && e.loadKey === load.loadKey
  );
  const showLogicError = hasLogicError;

  const showError = showEmptyError || showLogicError;

  //   change number of items
  const maxItems = load.maxLoads;
  const isDecreaseDisabled = value <= 1;
  const isIncreaseDisabled = value >= maxItems;

  const increaseNumberOfItems = () => {
    const currentNumberOfItems = value >= 1 ? value : 0;
    const nextNumberOfItems = currentNumberOfItems + 1;
    stepsApi.setLoadField({ load, field, value: nextNumberOfItems });
  };

  const decreaseNumberOfItems = () => {
    const currentNumberOfItems = value;
    const nextNumberOfItems = currentNumberOfItems - 1;
    stepsApi.setLoadField({ load, field, value: nextNumberOfItems });
  };

  const updateNumberOfItems = (e) => {
    stepsApi.setLoadField({ load, field, value: e.target.value });
  };

  const ignoreNotNumbers = (e) => {
    if (
      !(
        (e.keyCode > 95 && e.keyCode < 106) ||
        (e.keyCode > 47 && e.keyCode < 58) ||
        e.keyCode === 8 ||
        e.keyCode === 9
      )
    ) {
      e.preventDefault();
    }
  };
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <RangeControls
        onClick={decreaseNumberOfItems}
        disabled={isDecreaseDisabled}
      >
        -
      </RangeControls>
      <div>
        {showLogicError && isFocused && (
          <FieldError>
            {t('configuration.loads.max_items_warning', {
              max: load.maxLoads,
            })}
          </FieldError>
        )}
        <CustomInput
          placeholder={'Uds'}
          type="number"
          step={1}
          value={displayValue}
          onChange={updateNumberOfItems}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={ignoreNotNumbers}
          isFocused={isFocused}
          hasError={showError}
        />
      </div>
      <RangeControls
        onClick={increaseNumberOfItems}
        disabled={isIncreaseDisabled}
      >
        +
      </RangeControls>
    </div>
  );
};

SoFormLoadsAmountControl.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  /* secondary / white */

  background: #ffffff;
  border-radius: 4px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  border: 1px solid var(--grey300);
  border-radius: 4px;
  position: relative;
`;

export default styled(SoFormLoadsAmountControl)`
  ${regularCSS}
`;
